<template>
    <div class="grid grid-cols-4 gap-3">
        <InformationCard  v-for="item in recommends" :key="item.no" :report="item" :is-video="item.type==2"/>
    </div>
</template>
<script>
import { useFetch, defineComponent } from '@nuxtjs/composition-api'
import useRequest from '~/composables/useRequest'
import { getSearchRec } from '~/services/company'

import InformationCard from '@/views/company/InformationCard.vue'


export default defineComponent({
    name: 'SearchRec',
    components: {
        InformationCard
    },
    setup(){
        const {state: recommends, execute} = useRequest(getSearchRec, [], {
            immediate: false
        })

        useFetch(async () => {
            await execute(0);
        })

        return {
            recommends
        }
    }
})
</script>
<style lang="">

    

</style>